import React from 'react'
import Helmet from 'react-helmet'
import Layout from '../components/layout'

const Presentations = (props) => (
  <Layout>
    <Helmet>
      <title>Presentations</title>
    </Helmet>

    <div id="main" className="alt">
      <section id="about">
        <div className="inner">
          <header className="major">
            <h1>Presentations</h1>
          </header>
          <ul>
            <li>
              <a target="_blank" href="https://www.canva.com/design/DADqQam3Ab0/BEcjw_Eh9IAz0DhnUF8X6A/view">
                <h3>Social Media 101 - November 11th, 2019 </h3>
                <p>
                  I presented at the Homebuilder's Association of Jackson. This presentation focuses
                  on best practices for social media platforms, algorithms, and increasing your
                  overall engagement.
                </p>
              </a>
            </li>
          </ul>
        </div>
      </section>
    </div>
  </Layout>
)

export default Presentations

